// React imports
import { useContext } from "react";
// State
import { useDraftOrderStaff } from "../../state/draftOrderStaffState";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Components
import { OrderItemsSummaryTable } from "../../components/OrderItemsSummaryTable";
//  MUI
import Box from "@mui/material/Box";

export const ReviewOrder = ({ order, items, setItems }) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const person = order?.data?.staff[0];
  const orderNo = order?.data?.order?.no;

  // Get Order Staff Lines
  const { isPending, data, isSuccess } = useDraftOrderStaff(
    orderNo,
    person.staffLineNo,
    orderNo ? true : false,
  );

  // Success Function
  const successFunc = () => {
    const items = data.data.data.data.data.lines;
    const coreItems = items.filter((item) => item.type === "Core");
    const accessoryItems = items.filter((item) => item.type === "Accessory");
    const selectedItems = items.filter((item) => item.itemNo);
    setItems({
      selected: selectedItems,
      core: coreItems,
      accessory: accessoryItems,
    });
  };

  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Box sx={{ width: "100%", pt: 2, pb: 2, pl: 2 }}>
      <OrderItemsSummaryTable
        items={items.selected}
        order={order?.data?.order}
        person={person}
        staffRequest
        orderType="staffRequest"
      />
    </Box>
  );
};
